export default __webpack_public_path__ + "static/media/interaction-preview.4db9060b.png";